export let routes = [
  {
    path: '/x3-side-stored-card',
    name: 'x3-side-stored-card',
    component: () => import('@x3/js/side/stored-card/stored-card.vue'),
    meta: {
      vx_animate: 'none',
    },
  },{
    path: '/x3-side-stored-card-filtrate',
    name: 'x3-side-stored-card-filtrate',
    component: () => import('@x3/js/side/stored-card/filtrate/filtrate.vue'),
    meta: {
      vx_animate: 'none',
    },
  },
];

export let api = {
  xsStoredCard(options) {
    return new Promise((resolve, reject) => {
      app.router.push(
        '/x3-side-stored-card',
        route => {
          route.meta._resolve = resolve;
          route.meta._reject = reject;
          route.meta.options = options;
        },
        err => {
          console.log(err);
        }
      );
    });
  },
  xsStoredCardFiltrate(options) {
    return new Promise((resolve, reject) => {
      app.router.push(
        '/x3-side-stored-card-filtrate',
        route => {
          route.meta._resolve = resolve;
          route.meta._reject = reject;
          route.meta.options = options;
        },
        err => {
          console.log(err);
        }
      );
    });
  },
};
